import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import NotificationStack from './components/NotificationStack';
import DashboardLayout from './layouts/DashboardLayout';
import SantralGorusmeBridge from './components/SantralGorusmeBridge';
import { SoftphoneProvider } from './contexts/SoftphoneContext';
import { SantralGorusmeProvider } from './contexts/SantralGorusmeContext';
import { ServiceRecordWizardDraftProvider } from './contexts/ServiceRecordWizardDraftContext';
import LoginPage from './pages/LoginPage';
import BayiHomePage from './pages/BayiHomePage';
import BayiOnServisWizardPage from './pages/BayiOnServisWizardPage';
import HomePage from './pages/HomePage';
import UserManagementPage from './pages/UserManagementPage';
import TechServiceManagementPage from './pages/TechServiceManagementPage';
import BayiManagementPage from './pages/BayiManagementPage';
import BayiDetayPage from './pages/BayiDetayPage';
import TechServiceFormPage from './pages/TechServiceFormPage';
import UserFormPage from './pages/UserFormPage';
import ContentTypePage from './pages/ContentTypePage';
import BakimYonetimiPage from './pages/BakimYonetimiPage';
import ChecklistsPage from './pages/ChecklistsPage';
import TrainingVideosPage from './pages/TrainingVideosPage';
import CustomerManagementPage from './pages/CustomerManagementPage';
import CustomerFormPage from './pages/CustomerFormPage';
import ServiceRecordCreatePage from './pages/ServiceRecordCreatePage';
import { navigateToManualServiceRecordCreate } from './utils/serviceRecordCreateNavigation';
import ServiceRecordsPage from './pages/ServiceRecordsPage';
import ComplaintRecordsPage from './pages/ComplaintRecordsPage';
import ServiceRecordUpdatePage from './pages/ServiceRecordUpdatePage';
import GorusmeKayitlariPage from './pages/GorusmeKayitlariPage';
import OnServisKayitlariPage from './pages/OnServisKayitlariPage';
import CihazSorgulamaPage from './pages/CihazSorgulamaPage';
import TechServiceCihazSorgulamaPage from './pages/TechServiceCihazSorgulamaPage';
import AppointmentDetailPage from './pages/AppointmentDetailPage';
import TechServiceAppointmentsPage from './pages/TechServiceAppointmentsPage';
import TechServiceAppointmentDetailPage from './pages/TechServiceAppointmentDetailPage';
import TechServiceServiceRecordsPage from './pages/TechServiceServiceRecordsPage';
// TechnicianAvailabilityPage kaldırıldı - müsaitlik sistemi kaldırıldı
import SmsManagementPage from './pages/SmsManagementPage';
import CompletedAppointmentsPage from './pages/CompletedAppointmentsPage';
import OdemeProblemliRandevularPage from './pages/OdemeProblemliRandevularPage';
import CariHesapPage from './pages/CariHesapPage';
import CariHesaplarV2Page from './pages/CariHesaplarV2Page';
import SiparisTakipPage from './pages/SiparisTakipPage';
import IadeKargolariPage from './pages/IadeKargolariPage';
import TechServiceSiparisPage from './pages/TechServiceSiparisPage';
import TechServiceSiparisOnaylariPage from './pages/TechServiceSiparisOnaylariPage';
import TechServiceIadeKargolariPage from './pages/TechServiceIadeKargolariPage';
import TechServiceHakedislerPage from './pages/TechServiceHakedislerPage';
import TechServiceCariHesaplarPage from './pages/TechServiceCariHesaplarPage';
import RandevuIslemleriPage from './pages/RandevuIslemleriPage';
import RandevuTestPage from './pages/RandevuTestPage';
import TeknisyenPanelPage from './pages/TeknisyenPanelPage';
import HakedislerPage from './pages/HakedislerPage';
import RandevuBedelleriPage from './pages/RandevuBedelleriPage';
import GonderimlerPage from './pages/GonderimlerPage';
import StokKullanimPage from './pages/StokKullanimPage';
import StokYonetimiPage from './pages/StokYonetimiPage';
import IadeFaturalariPage from './pages/IadeFaturalariPage';
import AyarlarPage from './pages/AyarlarPage';
import DosyalarPage from './pages/DosyalarPage';
import DokumantasyonPage from './pages/DokumantasyonPage';
import DbBackupPage from './pages/DbBackupPage';
import RateLimitPage from './pages/RateLimitPage';
import TestVeriTemizlePage from './pages/TestVeriTemizlePage';
import EgitimTsKayitPage from './pages/EgitimTsKayitPage';
import SistemeRandevuTestPage from './pages/SistemeRandevuTestPage';
import ApkReleasesPage from './pages/ApkReleasesPage';
import AdminYapilacaklarPage from './pages/AdminYapilacaklarPage';
import MonitorPage from './pages/MonitorPage';
import DuyurularPage from './pages/DuyurularPage';
import TechServiceDuyurularPage from './pages/TechServiceDuyurularPage';
import TechServiceTechnicianManagementPage from './pages/TechServiceTechnicianManagementPage';
import TechServiceTechniciansPage from './pages/TechServiceTechniciansPage';
import TechServiceTechnicianDetailPage from './pages/TechServiceTechnicianDetailPage';
import RandevuDetayPublicPage from './pages/RandevuDetayPublicPage';
import AnketPublicPage from './pages/AnketPublicPage';
import AnketlerPage from './pages/AnketlerPage';
import AnketSorularPage from './pages/AnketSorularPage';
import AnketKampanyalarPage from './pages/AnketKampanyalarPage';
import ShortLinkRedirectPage from './pages/ShortLinkRedirectPage';
import BayilikBasvuruPublicPage from './pages/BayilikBasvuruPublicPage';
import NotFoundPage from './pages/NotFoundPage';
import BayilikOnaylariPage from './pages/BayilikOnaylariPage';
import TsKayitPublicPage from './pages/TsKayitPublicPage';
import SifreSifirlamaPublicPage from './pages/SifreSifirlamaPublicPage';
import TsKayitOnaylariPage from './pages/TsKayitOnaylariPage';
import LegalPublicPage from './pages/LegalPublicPage';
import PublicFileDownloadPage from './pages/PublicFileDownloadPage';
import StoreLinksPage from './pages/StoreLinksPage';
import CihazDegisimiPage from './pages/CihazDegisimiPage';
import CihazDegisimiAdminPage from './pages/CihazDegisimiAdminPage';
import BekleyenIslemlerPage from './pages/BekleyenIslemlerPage';
import IstatistikCihazlarPage from './pages/IstatistikCihazlarPage';
import IstatistikArizaPage from './pages/IstatistikArizaPage';
import TechServicesMapPage from './pages/TechServicesMapPage';
import TechProvinceLabelsEditorPage from './pages/TechProvinceLabelsEditorPage';
import TestPanelPage from './pages/TestPanelPage';
import ReviewAppLoginPage from './pages/ReviewAppLoginPage';
import ReviewAppPage from './pages/ReviewAppPage';
import MusteriHizmetleriPage from './pages/MusteriHizmetleriPage';
import OturumlarPage from './pages/OturumlarPage';
import { useSessionGuard } from './hooks/useSessionGuard';
import { getStoredUser } from './services/apiClient';
import { isBayiPanel, getPostLoginPath } from './utils/panel';
import './App.css';

/** Dahili atanabilen (softphone) roller — provider sayfa geçişinde unmount olmamalı */
const SANTRAL_ROLLERI = ['admin', 'mod', 'sales'];
const santralRolUygun = (user) => SANTRAL_ROLLERI.includes(String(user?.rol || '').toLowerCase());

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}>
        <div style={{ 
          fontSize: '16px', 
          color: '#64748b' 
        }}>
          Yükleniyor...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.rol === 'review-app') {
    return <Navigate to="/review-app" replace />;
  }

  return children;
}

function ReviewAppRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      }}>
        <div style={{ fontSize: '16px', color: '#64748b' }}>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/review-app/login" replace />;
  }

  if (user?.rol !== 'review-app') {
    return <Navigate to={getPostLoginPath(user?.rol)} replace />;
  }

  return children;
}

// Admin Only Route Component
function AdminRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}>
        <div style={{ 
          fontSize: '16px', 
          color: '#64748b' 
        }}>
          Yükleniyor...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Admin kontrolü
  if (user?.rol !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Admin or Moderator Route Component
function AdminOrModeratorRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}>
        <div style={{ 
          fontSize: '16px', 
          color: '#64748b' 
        }}>
          Yükleniyor...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Admin veya moderator kontrolü
  if (user?.rol !== 'admin' && user?.rol !== 'mod' && user?.rol !== 'moderator') {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Admin, Mod, Moderator veya Sales (Servis sayfaları)
function AdminOrModeratorOrSalesRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}>
        <div style={{ fontSize: '16px', color: '#64748b' }}>Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.rol !== 'admin' && user?.rol !== 'mod' && user?.rol !== 'moderator' && user?.rol !== 'sales') {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Teknisyen Route - sadece tech-person
function TeknisyenRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
        <div style={{ fontSize: '16px', color: '#64748b' }}>Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.rol !== 'tech-person') {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Sevkiyat Route - sadece sevkiyat
function SevkiyatRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="App" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
        <div style={{ fontSize: '16px', color: '#64748b' }}>Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.rol !== 'sevkiyat') {
    return <Navigate to={getPostLoginPath(user?.rol)} replace />;
  }

  return children;
}

function BayiRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const effectiveRol = user?.rol || getStoredUser()?.rol;

  if (isLoading) {
    return (
      <div className="App" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
        <div style={{ fontSize: '16px', color: '#64748b' }}>Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (effectiveRol !== 'bayi') {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function SuperadminRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const effectiveRol = user?.rol || getStoredUser()?.rol;

  if (isLoading) {
    return (
      <div className="App" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}>
        <div style={{ fontSize: '16px', color: '#94a3b8' }}>Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (effectiveRol !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Tech Service Route Component
function TechServiceRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Auth yüklenene kadar bekle
  if (isLoading) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}>
        <div style={{ 
          fontSize: '16px', 
          color: '#64748b' 
        }}>
          Yükleniyor...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // User yüklenene kadar bekle (isLoading false ama user henüz null olabilir)
  if (!user) {
    return (
      <div className="App" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
      }}>
        <div style={{ 
          fontSize: '16px', 
          color: '#64748b' 
        }}>
          Yükleniyor...
        </div>
      </div>
    );
  }

  const userRole = user?.rol?.toLowerCase?.() || user?.rol || '';
  const isTechService = userRole === 'tech-service' ||
                        userRole === 'teknikservis' || 
                        userRole === 'techservice' || 
                        userRole === 'teknik-servis' ||
                        user?.rol === 'tech-service' ||
                        user?.rol === 'teknikServis' || 
                        user?.rol === 'techService';
  const isTechPerson = userRole === 'tech-person' || user?.rol === 'tech-person';
  const canAccessTechServiceArea = isTechService || isTechPerson;

  if (!canAccessTechServiceArea) {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Dashboard Wrapper Component
function DashboardWrapper({ children, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const currentUser = user?.kullaniciAdi || user?.email || user?.name || 'Kullanıcı';

  // URL'den activePage'i belirle
  const getActivePage = () => {
    const path = location.pathname;
    if (path.startsWith('/users')) return 'users';
    if (path.startsWith('/teknik-servisler/il-etiketleri')) return 'teknik-servisler-etiket';
    if (path.startsWith('/teknik-servisler')) return 'teknik-servisler';
    if (path.startsWith('/tech-services')) return 'tech-services';
    if (path.startsWith('/bayiler')) return 'bayiler';
    if (path.startsWith('/customers')) return 'customers';
    if (path.startsWith('/cihaz-sorgulama')) return 'cihaz-sorgulama';
    if (path.startsWith('/complaint-records')) return 'complaint-records';
    if (path.startsWith('/on-servis-kayitlari')) return 'on-servis-kayitlari';
    if (path.startsWith('/bayilik-onaylari')) return 'bayilik-onaylari';
    if (path.startsWith('/servis-onaylari')) return 'servis-onaylari';
    if (path.startsWith('/gorusme-kayitlari')) return 'gorusme-kayitlari';
    if (path.startsWith('/service-records')) return 'service-records';
    if (path === '/contents/urun') return 'contents-urun';
    if (path === '/contents/parca') return 'contents-parca';
    if (path === '/contents/islem') return 'contents-islem';
    if (path === '/contents/ariza') return 'contents-ariza';
    if (path === '/contents/bakim-yonetimi') return 'contents-bakim-yonetimi';
    if (path === '/checklists') return 'checklists';
    if (path.startsWith('/contents')) return 'contents';
    if (path.startsWith('/appointments')) return 'appointments';
    if (path.startsWith('/completed-appointments')) return 'completed-appointments';
    if (path.startsWith('/sms')) return 'sms';
    if (path.startsWith('/stok-yonetimi')) return 'stok-yonetimi';
    if (path.startsWith('/cari-hesaplar')) return 'cari-hesaplar';
    if (path.startsWith('/siparis-takip')) return 'siparis-takip';
    if (path.startsWith('/bekleyen-islemler')) return 'bekleyen-islemler';
    if (path.startsWith('/iade-kargolari')) return 'iade-kargolari';
    if (path.startsWith('/cihaz-degisimi')) return 'cihaz-degisimi';
    if (path.startsWith('/randevu-bedelleri')) return 'randevu-bedelleri';
    if (path.startsWith('/hakedisler')) return 'hakedisler';
    if (path.startsWith('/istatistik/cihazlar')) return 'istatistik-cihazlar';
    if (path.startsWith('/istatistik/ariza')) return 'istatistik-ariza';
    if (path.startsWith('/gonderimler')) return 'gonderimler';
    if (path.startsWith('/iade-faturalari')) return 'iade-faturalari';
    if (path.startsWith('/hesap/oturumlar')) return 'hesap-oturumlar';
    if (path.startsWith('/duyurular')) return 'duyurular';
    if (path.startsWith('/ayarlar')) return 'ayarlar';
    if (path.startsWith('/yapilacaklar')) return 'yapilacaklar';
    if (path.startsWith('/monitor')) return 'monitor';
    if (path.startsWith('/dokumantasyon')) return 'dokumantasyon';
    if (path.startsWith('/db-yedekleme')) return 'db-yedekleme';
    if (path.startsWith('/rate-limit')) return 'rate-limit';
    if (path.startsWith('/test-veri-temizle')) return 'test-veri-temizle';
    if (path.startsWith('/egitim-ts-kayitlari')) return 'egitim-ts-kayitlari';
    if (path.startsWith('/apk-surumleri')) return 'apk-surumleri';
    if (path.startsWith('/tech-service/teknisyenler')) return 'tech-service-teknisyenler';
    if (path.startsWith('/tech-service/kullanicilar')) return 'tech-service-kullanicilar';
    if (path.startsWith('/tech-service/duyurular')) return 'tech-service-duyurular';
    if (path.startsWith('/tech-service/siparis-onaylari')) return 'tech-service-siparis-onaylari';
    if (path.startsWith('/tech-service/siparisler')) return 'tech-service-siparisler';
    if (path.startsWith('/tech-service/iade-kargolari')) return 'tech-service-iade-kargolari';
    if (path.startsWith('/tech-service/cihaz-sorgulama')) return 'tech-service-cihaz-sorgulama';
    if (path.startsWith('/tech-service/cihaz-degisimi')) return 'tech-service-cihaz-degisimi';
    if (path.startsWith('/tech-service/hakedisler')) return 'tech-service-hakedisler';
    if (path.startsWith('/tech-service/gonderimler')) return 'tech-service-gonderimler';
    if (path.startsWith('/tech-service/cari-hesaplar')) return 'tech-service-cari-hesaplar';
    if (path.startsWith('/tech-service/stok-kullanim')) return 'tech-service-stok-kullanim';
    if (path.startsWith('/tech-service/iade-faturalari')) return 'tech-service-iade-faturalari';
    if (path.startsWith('/tech-service/randevu-islemleri')) return 'tech-service-randevu-islemleri';
    if (path.startsWith('/tech-service/randevu-test')) return 'tech-service-randevu-test';
    if (path.startsWith('/teknisyen/randevu-test')) return 'teknisyen-randevu-test';
    if (path.startsWith('/teknisyen/randevular')) return 'teknisyen-randevular';
    if (path.startsWith('/teknisyen')) return 'teknisyen';
    if (path.startsWith('/sevkiyat/siparisler')) return 'sevkiyat-siparisler';
    if (path.startsWith('/sevkiyat/iade-kargolari')) return 'sevkiyat-iade-kargolari';
    if (path.startsWith('/sevkiyat/gonderimler')) return 'sevkiyat-gonderimler';
    if (path.startsWith('/sevkiyat')) return 'sevkiyat-siparisler';
    return 'home';
  };

  const handleNavigate = (pageId) => {
    if (pageId === 'home') {
      navigate('/');
    } else if (pageId === 'users') {
      navigate('/users');
    } else if (pageId === 'tech-services') {
      navigate('/tech-services');
    } else if (pageId === 'bayiler') {
      navigate('/bayiler');
    } else if (pageId === 'teknik-servisler') {
      navigate('/teknik-servisler');
    } else if (pageId === 'teknik-servisler-etiket') {
      navigate('/teknik-servisler/il-etiketleri');
    } else if (pageId === 'customers') {
      navigate('/customers');
    } else if (pageId === 'service-records' || pageId === 'service-records-create') {
      if (pageId === 'service-records-create') {
        navigateToManualServiceRecordCreate(navigate);
      } else {
        navigate('/service-records');
      }
    } else if (pageId === 'cihaz-sorgulama') {
      navigate('/cihaz-sorgulama');
    } else if (pageId === 'complaint-records') {
      navigate('/complaint-records');
    } else if (pageId === 'on-servis-kayitlari') {
      navigate('/on-servis-kayitlari');
    } else if (pageId === 'bayilik-onaylari') {
      navigate('/bayilik-onaylari');
    } else if (pageId === 'servis-onaylari') {
      navigate('/servis-onaylari');
    } else if (pageId === 'gorusme-kayitlari') {
      navigate('/gorusme-kayitlari');
    } else if (pageId === 'contents') {
      navigate('/contents/urun');
    } else if (pageId === 'contents-urun') {
      navigate('/contents/urun');
    } else if (pageId === 'contents-parca') {
      navigate('/contents/parca');
    } else if (pageId === 'contents-islem') {
      navigate('/contents/islem');
    } else if (pageId === 'contents-ariza') {
      navigate('/contents/ariza');
    } else if (pageId === 'contents-bakim-yonetimi') {
      navigate('/contents/bakim-yonetimi');
    } else if (pageId === 'checklists') {
      navigate('/checklists');
    } else if (pageId === 'appointments') {
      navigate('/appointments');
    } else if (pageId === 'completed-appointments') {
      navigate('/completed-appointments');
    } else if (pageId === 'sms') {
      navigate('/sms');
    } else if (pageId === 'stok-yonetimi') {
      navigate('/stok-yonetimi');
    } else if (pageId === 'cari-hesaplar') {
      navigate('/cari-hesaplar');
    } else if (pageId === 'siparis-takip') {
      navigate('/siparis-takip');
    } else if (pageId === 'bekleyen-islemler') {
      navigate('/bekleyen-islemler');
    } else if (pageId === 'iade-kargolari') {
      navigate('/iade-kargolari');
    } else if (pageId === 'cihaz-degisimi') {
      navigate('/cihaz-degisimi');
    } else if (pageId === 'randevu-bedelleri') {
      navigate('/randevu-bedelleri');
    } else if (pageId === 'hakedisler') {
      navigate('/hakedisler');
    } else if (pageId === 'istatistik-cihazlar') {
      navigate('/istatistik/cihazlar');
    } else if (pageId === 'istatistik-ariza') {
      navigate('/istatistik/ariza');
    } else if (pageId === 'gonderimler') {
      navigate('/gonderimler');
    } else if (pageId === 'iade-faturalari') {
      navigate('/iade-faturalari');
    } else if (pageId === 'hesap-oturumlar') {
      navigate('/hesap/oturumlar');
    } else if (pageId === 'duyurular') {
      navigate('/duyurular');
    } else if (pageId === 'ayarlar') {
      navigate('/ayarlar');
    } else if (pageId === 'yapilacaklar') {
      navigate('/yapilacaklar');
    } else if (pageId === 'monitor') {
      navigate('/monitor');
    } else if (pageId === 'dokumantasyon') {
      navigate('/dokumantasyon');
    } else if (pageId === 'db-yedekleme') {
      navigate('/db-yedekleme');
    } else if (pageId === 'rate-limit') {
      navigate('/rate-limit');
    } else if (pageId === 'test-veri-temizle') {
      navigate('/test-veri-temizle');
    } else if (pageId === 'egitim-ts-kayitlari') {
      navigate('/egitim-ts-kayitlari');
    } else if (pageId === 'apk-surumleri') {
      navigate('/apk-surumleri');
    } else if (pageId === 'tech-service-teknisyenler') {
      navigate('/tech-service/teknisyenler');
    } else if (pageId === 'tech-service-kullanicilar') {
      navigate('/tech-service/kullanicilar');
    } else if (pageId === 'tech-service-duyurular') {
      navigate('/tech-service/duyurular');
    } else if (pageId === 'tech-service-siparis-onaylari') {
      navigate('/tech-service/siparis-onaylari');
    } else if (pageId === 'tech-service-siparisler') {
      navigate('/tech-service/siparisler');
    } else if (pageId === 'tech-service-iade-kargolari') {
      navigate('/tech-service/iade-kargolari');
    } else if (pageId === 'tech-service-cihaz-sorgulama') {
      navigate('/tech-service/cihaz-sorgulama');
    } else if (pageId === 'tech-service-cihaz-degisimi') {
      navigate('/tech-service/cihaz-degisimi');
    } else if (pageId === 'tech-service-hakedisler') {
      navigate('/tech-service/hakedisler');
    } else if (pageId === 'tech-service-gonderimler') {
      navigate('/tech-service/gonderimler');
    } else if (pageId === 'tech-service-cari-hesaplar') {
      navigate('/tech-service/cari-hesaplar');
    } else if (pageId === 'tech-service-stok-kullanim') {
      navigate('/tech-service/stok-kullanim');
    } else if (pageId === 'tech-service-iade-faturalari') {
      navigate('/tech-service/iade-faturalari');
    } else if (pageId === 'tech-service-randevu-islemleri') {
      navigate('/tech-service/randevu-islemleri');
    } else if (pageId === 'tech-service-randevu-test') {
      navigate('/tech-service/randevu-test');
    } else if (pageId === 'teknisyen') {
      navigate('/teknisyen');
    } else if (pageId === 'teknisyen-randevular') {
      navigate('/teknisyen/randevular');
    } else if (pageId === 'teknisyen-randevu-test') {
      navigate('/teknisyen/randevu-test');
    } else if (pageId === 'sevkiyat-siparisler') {
      navigate('/sevkiyat/siparisler');
    } else if (pageId === 'sevkiyat-iade-kargolari') {
      navigate('/sevkiyat/iade-kargolari');
    } else if (pageId === 'sevkiyat-gonderimler') {
      navigate('/sevkiyat/gonderimler');
    }
  };

  const activePage = getActivePage();

  return (
    <DashboardLayout
      currentUser={currentUser}
      onLogout={onLogout}
      activePage={activePage}
      onNavigate={handleNavigate}
      user={user}
    >
      {children}
    </DashboardLayout>
  );
}

function AppContent() {
  const { isAuthenticated, logout, user, isSessionChecking } = useAuth();
  const authRol = user?.rol || getStoredUser()?.rol;
  const navigate = useNavigate();

  useSessionGuard({
    enabled: isAuthenticated,
    onSessionInvalid: () => {
      navigate('/login', { replace: true });
    },
  });

  useEffect(() => {
    if (!isBayiPanel() && isAuthenticated && authRol === 'bayi') {
      logout().finally(() => {
        navigate('/login', { replace: true });
      });
    }
  }, [isAuthenticated, authRol, logout, navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      if (window.showNotification) {
        window.showNotification('success', 'Çıkış yapıldı');
      }
    } catch (error) {
      if (window.showNotification) {
        window.showNotification('error', 'Çıkış yapılırken bir hata oluştu');
      }
    }
  };

  const bayiRoutes = (
    <div className="App">
      <Routes>
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <LoginPage />
            ) : (
              <Navigate to={getPostLoginPath(authRol)} replace />
            )
          }
        />
        <Route path="/bayi-basvuru" element={<NotFoundPage />} />
        <Route
          path="/bayi-basvuru/:token"
          element={<BayilikBasvuruPublicPage />}
        />
        <Route path="/a/:token" element={<AnketPublicPage />} />
        <Route
          path="/on-servis-kaydi"
          element={
            <BayiRoute>
              <BayiOnServisWizardPage onLogout={handleLogout} />
            </BayiRoute>
          }
        />
        <Route
          path="/"
          element={
            <BayiRoute>
              <BayiHomePage onLogout={handleLogout} />
            </BayiRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <NotificationStack />
    </div>
  );

  const appRoutes = (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={
            !isAuthenticated ? (
              <LoginPage />
            ) : (
              <Navigate to={getPostLoginPath(authRol)} replace />
            )
          } 
        />
        <Route path="/d/:token" element={<RandevuDetayPublicPage />} />
        <Route path="/a/:token" element={<AnketPublicPage />} />
        <Route path="/x/:code" element={<ShortLinkRedirectPage />} />
        <Route path="/s/:token" element={<TsKayitPublicPage />} />
        <Route path="/sifre/:token" element={<SifreSifirlamaPublicPage />} />
        <Route path="/bayi-basvuru" element={<NotFoundPage />} />
        <Route path="/bayi-basvuru/:token" element={<BayilikBasvuruPublicPage />} />
        <Route path="/kvkk" element={<LegalPublicPage slug="kvkk" />} />
        <Route path="/kullanim-kosullari" element={<LegalPublicPage slug="kullanim-kosullari" />} />
        <Route path="/gizlilik" element={<LegalPublicPage slug="gizlilik" />} />
        <Route path="/privacy" element={<LegalPublicPage slug="privacy" />} />
        <Route path="/musteri-verileri-taahhut" element={<LegalPublicPage slug="musteri-verileri-taahhut" />} />
        <Route path="/acik-riza" element={<LegalPublicPage slug="acik-riza" />} />
        <Route path="/files/:token" element={<PublicFileDownloadPage />} />
        <Route path="/stores" element={<StoreLinksPage />} />

        <Route
          path="/review-app/login"
          element={
            isAuthenticated && authRol === 'review-app' ? (
              <Navigate to="/review-app" replace />
            ) : (
              <ReviewAppLoginPage />
            )
          }
        />
        <Route
          path="/review-app"
          element={
            <ReviewAppRoute>
              <ReviewAppPage onLogout={handleLogout} />
            </ReviewAppRoute>
          }
        />

        {/* Protected Routes - teknisyen girişte panele yönlendirilir */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              {authRol === 'superadmin' ? (
                <Navigate to="/test-panel" replace />
              ) : authRol === 'review-app' ? (
                <Navigate to="/review-app" replace />
              ) : authRol === 'tech-person' ? (
                <Navigate to="/teknisyen" replace />
              ) : authRol === 'sevkiyat' ? (
                <Navigate to="/sevkiyat" replace />
              ) : (
                <DashboardWrapper onLogout={handleLogout}>
                  <HomePage />
                </DashboardWrapper>
              )}
            </ProtectedRoute>
          }
        />

        <Route
          path="/test-panel"
          element={
            <ProtectedRoute>
              <SuperadminRoute>
                <TestPanelPage onLogout={handleLogout} />
              </SuperadminRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <UserManagementPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/users/:id/edit"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <UserFormPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/tech-services"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceManagementPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/bayiler"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <BayiManagementPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/bayiler/:id"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <BayiDetayPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/tech-services/add"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceFormPage mode="create" />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/tech-services/:id/edit"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceFormPage mode="edit" />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route path="/categories" element={<Navigate to="/contents/urun" replace />} />
        <Route path="/contents" element={<Navigate to="/contents/urun" replace />} />

        <Route
          path="/contents/bakim-yonetimi"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <BakimYonetimiPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/checklists"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <ChecklistsPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/musteri-hizmetleri"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <MusteriHizmetleriPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/contents/:contentType"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <ContentTypePage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/training-videos"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TrainingVideosPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/customers"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <CustomerManagementPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/customers/:id/edit"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <CustomerFormPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/service-records/create"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <ServiceRecordCreatePage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/cihaz-sorgulama"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <CihazSorgulamaPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/gorusme-kayitlari"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <GorusmeKayitlariPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/on-servis-kayitlari"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <OnServisKayitlariPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/bayilik-onaylari"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <BayilikOnaylariPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/servis-onaylari"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TsKayitOnaylariPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />

        <Route
          path="/teknik-servisler/il-etiketleri"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechProvinceLabelsEditorPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        <Route
          path="/teknik-servisler"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServicesMapPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/service-records"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <ServiceRecordsPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/complaint-records"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <ComplaintRecordsPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/service-records/:id/update"
          element={
            <ProtectedRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <ServiceRecordUpdatePage />
              </DashboardWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/service-records/:servisKaydiId/appointments/:randevuId"
          element={
            <AdminOrModeratorOrSalesRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <AppointmentDetailPage />
              </DashboardWrapper>
            </AdminOrModeratorOrSalesRoute>
          }
        />

        <Route
          path="/appointments/:id"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceAppointmentDetailPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        <Route
          path="/appointments"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceAppointmentsPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknisyen Müsaitlik Yönetimi - Kaldırıldı */}

        {/* Teknik Servis Servis Kayıtları */}
        <Route
          path="/tech-service/service-records"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceServiceRecordsPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis Sipariş Onayları */}
        <Route
          path="/tech-service/siparis-onaylari"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceSiparisOnaylariPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis Sipariş Sistemi */}
        <Route
          path="/tech-service/siparisler"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceSiparisPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis İade Kargoları */}
        <Route
          path="/tech-service/iade-kargolari"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceIadeKargolariPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis Cihaz Sorgulama */}
        <Route
          path="/tech-service/cihaz-sorgulama"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceCihazSorgulamaPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis Cihaz Değişimi */}
        <Route
          path="/tech-service/cihaz-degisimi"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <CihazDegisimiPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis Hakedişler */}
        <Route
          path="/tech-service/hakedisler"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceHakedislerPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis Gönderimler */}
        <Route
          path="/tech-service/gonderimler"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <GonderimlerPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />
        {/* Teknik Servis Cari Hareketler */}
        <Route
          path="/tech-service/cari-hesaplar"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceCariHesaplarPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />
        {/* Teknik Servis Stok Kullanımı */}
        <Route
          path="/tech-service/stok-kullanim"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <StokKullanimPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknik Servis İade Faturaları */}
        <Route
          path="/tech-service/iade-faturalari"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <IadeFaturalariPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Randevu İşlemleri - Mobil akış simülasyonu */}
        <Route
          path="/tech-service/randevu-islemleri"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <RandevuIslemleriPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Randevu Test - Tarayıcıdan teknisyen akışı test (update-status, OTP, varsayılan konum) */}
        <Route
          path="/tech-service/randevu-test"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <RandevuTestPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        <Route
          path="/tech-service/teknisyenler"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceTechniciansPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />
        <Route
          path="/tech-service/teknisyenler/:teknisyenId"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceTechnicianDetailPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        <Route
          path="/tech-service/kullanicilar"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceTechnicianManagementPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        <Route
          path="/tech-service/duyurular"
          element={
            <TechServiceRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceDuyurularPage />
              </DashboardWrapper>
            </TechServiceRoute>
          }
        />

        {/* Teknisyen Paneli - sadece tech-person */}
        <Route
          path="/teknisyen"
          element={
            <TeknisyenRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TeknisyenPanelPage />
              </DashboardWrapper>
            </TeknisyenRoute>
          }
        />
        <Route
          path="/teknisyen/randevular"
          element={
            <TeknisyenRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <TechServiceAppointmentsPage />
              </DashboardWrapper>
            </TeknisyenRoute>
          }
        />
        <Route
          path="/teknisyen/randevu-test"
          element={
            <TeknisyenRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <RandevuTestPage />
              </DashboardWrapper>
            </TeknisyenRoute>
          }
        />

        {/* Sevkiyat Paneli - sadece sevkiyat */}
        <Route
          path="/sevkiyat"
          element={
            <SevkiyatRoute>
              <Navigate to="/sevkiyat/siparisler" replace />
            </SevkiyatRoute>
          }
        />
        <Route
          path="/sevkiyat/siparisler"
          element={
            <SevkiyatRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <SiparisTakipPage cargoOnly />
              </DashboardWrapper>
            </SevkiyatRoute>
          }
        />
        <Route
          path="/sevkiyat/iade-kargolari"
          element={
            <SevkiyatRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <IadeKargolariPage />
              </DashboardWrapper>
            </SevkiyatRoute>
          }
        />
        <Route
          path="/sevkiyat/gonderimler"
          element={
            <SevkiyatRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <GonderimlerPage cargoOnly />
              </DashboardWrapper>
            </SevkiyatRoute>
          }
        />

        {/* SMS Yönetimi */}
                <Route
                  path="/sms"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <SmsManagementPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />

                <Route
                  path="/completed-appointments"
                  element={
                    <AdminOrModeratorRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <CompletedAppointmentsPage />
                      </DashboardWrapper>
                    </AdminOrModeratorRoute>
                  }
                />

                <Route
                  path="/odeme-problemli-randevular"
                  element={
                    <AdminOrModeratorRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <OdemeProblemliRandevularPage />
                      </DashboardWrapper>
                    </AdminOrModeratorRoute>
                  }
                />

                <Route
                  path="/cari-hesaplar"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <CariHesaplarV2Page />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/cari-hesaplar/teknik-servis/:id"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <CariHesaplarV2Page />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/bekleyen-islemler"
                  element={
                    <AdminOrModeratorRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <BekleyenIslemlerPage />
                      </DashboardWrapper>
                    </AdminOrModeratorRoute>
                  }
                />
                <Route
                  path="/siparis-takip"
                  element={
                    <AdminOrModeratorRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <SiparisTakipPage />
                      </DashboardWrapper>
                    </AdminOrModeratorRoute>
                  }
                />
                <Route
                  path="/iade-kargolari"
                  element={
                    <AdminOrModeratorRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <IadeKargolariPage />
                      </DashboardWrapper>
                    </AdminOrModeratorRoute>
                  }
                />
                <Route
                  path="/cihaz-degisimi"
                  element={
                    <AdminOrModeratorRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <CihazDegisimiAdminPage />
                      </DashboardWrapper>
                    </AdminOrModeratorRoute>
                  }
                />
                <Route
                  path="/randevu-bedelleri"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <RandevuBedelleriPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/stok-yonetimi"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <StokYonetimiPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/stok-ara"
                  element={<Navigate to="/stok-yonetimi?tab=stok-ara" replace />}
                />
                <Route
                  path="/teknik-servis-stoklari"
                  element={<Navigate to="/stok-yonetimi?tab=teknik-servis-stoklari" replace />}
                />
                <Route
                  path="/hakedisler"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <HakedislerPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/istatistik/cihazlar"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <IstatistikCihazlarPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/istatistik/ariza"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <IstatistikArizaPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/gonderimler"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <GonderimlerPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/iade-faturalari"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <IadeFaturalariPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/dosyalar"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <DosyalarPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/dokumantasyon/*"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <DokumantasyonPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/db-yedekleme"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <DbBackupPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/rate-limit"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <RateLimitPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/test-veri-temizle"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <TestVeriTemizlePage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/egitim-ts-kayitlari"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <EgitimTsKayitPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/sisteme-randevu-test"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <SistemeRandevuTestPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/apk-surumleri"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <ApkReleasesPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/ayarlar"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <AyarlarPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/km-ayarlari"
                  element={
                    <AdminRoute>
                      <Navigate to="/ayarlar?tab=km" replace />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/iskonto-ayari"
                  element={
                    <AdminRoute>
                      <Navigate to="/ayarlar?tab=iskonto" replace />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/yapilacaklar"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <AdminYapilacaklarPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/monitor"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <MonitorPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />
                <Route
                  path="/hesap/oturumlar"
                  element={
                    <ProtectedRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <OturumlarPage />
                      </DashboardWrapper>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/duyurular"
                  element={
                    <AdminRoute>
                      <DashboardWrapper onLogout={handleLogout}>
                        <DuyurularPage />
                      </DashboardWrapper>
                    </AdminRoute>
                  }
                />

        <Route
          path="/anketler"
          element={
            <AdminOrModeratorRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <AnketlerPage />
              </DashboardWrapper>
            </AdminOrModeratorRoute>
          }
        />
        <Route
          path="/anketler/sorular"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <AnketSorularPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />
        <Route
          path="/anketler/kampanyalar"
          element={
            <AdminRoute>
              <DashboardWrapper onLogout={handleLogout}>
                <AnketKampanyalarPage />
              </DashboardWrapper>
            </AdminRoute>
          }
        />

        {/* Catch all */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <NotificationStack />
    </div>
  );

  if (isBayiPanel()) {
    return bayiRoutes;
  }

  if (isAuthenticated && santralRolUygun(user)) {
    return (
      <ServiceRecordWizardDraftProvider>
        <SoftphoneProvider>
          <SantralGorusmeProvider>
            <SantralGorusmeBridge />
            {appRoutes}
          </SantralGorusmeProvider>
        </SoftphoneProvider>
      </ServiceRecordWizardDraftProvider>
    );
  }

  if (isAuthenticated) {
    return (
      <ServiceRecordWizardDraftProvider>
        {appRoutes}
      </ServiceRecordWizardDraftProvider>
    );
  }

  return appRoutes;
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

